export const yes = {
  id: 6,
  name: "YES Programme",
  slug: "yes",
  status: "completed",
  description: "Youth Employment Service initiative for B-BBEE level enhancement",
  deadline: "31 Jan 2026",
  current_points: 2.0,
  total_points: 2,
  target: 2,
  workflow_completed: 6,
  workflow_total: 6,
  icon: "fas fa-bullseye",
  theme: { gradientFrom: "#22c55e", gradientTo: "#84cc16" },
  steps: [
    {
      id: "yes-1",
      title: "Register with YES Programme",
      description: "Complete registration on YES4Youth platform and obtain company profile",
      status: "completed",
      due: "01 Dec 2025",
      owner_initials: "TM",
      owner_name: "Thabo Molefe",
      owner_role: "HR Manager",
      owner_email: "thabo.molefe@company.co.za",
      owner_number: "+27 84 345 6789",
      owner_role_desc: "Oversees organizational structure and employment equity",
      required_documents: ["YES Registration Confirmation", "Company Profile"],
    },
  ],
};
